import React, { FC } from 'react';
import { View } from 'react-native';
import { useJobDetails } from '@v2/pages/common/hooks/useJobDetails';
import { getNCFilesByProductionOperationId } from '@reducers/manufacture';
import { getProductionBatchByProductionOperationId, operationsSearch } from '@reducers/search';
import { updateHeaderConfig } from '@reducers/details';
import { connect } from 'react-redux';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import NCFileBatchEvents from '@v2/pages/common/components/NCFileBatchEvents';
import { NcFileBatchEventType } from '@v2/pages/common/enums';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import { ReducerEntityWithLoadingState } from '@v2/pages/common/interfaces';
import { ProductionBatchStatistics } from '@interfaces/search';

interface JobDetailsBatchEventsChangeProps {
  batch: ReducerEntityWithLoadingState<ProductionBatchStatistics | null>;
}

const JobDetailsBatchEventsChangeComponent: FC<JobDetailsBatchEventsChangeProps> = ({
  updateHeaderConfig,
  operationsSearch,
  getNCFilesByProductionOperationId,
  getProductionBatchByProductionOperationId,
  batch,
}) => {
  const title = useTitle();

  useJobDetails({
    updateHeaderConfig,
    operationsSearch,
    getNCFilesByProductionOperationId,
    getProductionBatchByProductionOperationId,
  });

  const productionBatchId = batch.data?.productionBatchId;

  return (
    <DetailsPageWrapper title={title.batch}>
      <View style={{ flex: 1 }}>
        <NCFileBatchEvents {...{ eventType: NcFileBatchEventType.CHANGE, productionBatchId }} />
      </View>
    </DetailsPageWrapper>
  );
};

const JobDetailsBatchEventsChange = connect(({ batch: { batch } }) => ({ batch }), {
  updateHeaderConfig,
  operationsSearch,
  getNCFilesByProductionOperationId,
  getProductionBatchByProductionOperationId,
})(JobDetailsBatchEventsChangeComponent);

export { JobDetailsBatchEventsChange };
